export const LEAD_NOTE_BODY_MAX_LENGTH = 2000;

export type LeadNote = {
  merchantId: string;
  id: string;
  leadId: string;
  body: string;
  authorMemberId: string;
  authorEmail: string;
  authorName?: string;
  editedAt?: string;
  editedByEmail?: string;
  editedByName?: string;
  createdAt: string;
  updatedAt: string;
};

export type LeadNoteKey = { merchantId: string; id: string };

export type ListLeadNotesInput = { merchantId: string; leadId: string };

export type CreateLeadNoteInput = Pick<
  LeadNote,
  "merchantId" | "leadId" | "body" | "authorMemberId" | "authorEmail" | "authorName"
>;

export type UpdateLeadNoteBodyInput = LeadNoteKey & {
  body: string;
  editedAt: string;
  editedByEmail: string;
  editedByName?: string;
};
